/* mvt-page.js: hides the mobile sticky bar while an offer box is on screen */
(function () {
  var bar = document.querySelector('[data-mvt-bar]');
  if (!bar || !('IntersectionObserver' in window)) return;
  var seen = [];
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var i = seen.indexOf(e.target);
      if (e.isIntersecting && i < 0) seen.push(e.target);
      if (!e.isIntersecting && i > -1) seen.splice(i, 1);
    });
    bar.classList.toggle('mvt-bar--hide', seen.length > 0);
  }, { threshold: 0.15 });
  [].slice.call(document.querySelectorAll('[data-mvt-offer]')).forEach(function (t) { io.observe(t); });
})();

/* moving number in the byline: drifts a few steps around the starting value */
(function () {
  var el = document.querySelector('[data-mvt-live]');
  if (!el) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var base = parseInt(el.getAttribute('data-mvt-live'), 10);
  if (!base) return;
  var cur = base, span = Math.max(5, Math.round(base * 0.08));
  function step() {
    var d = Math.floor(Math.random() * 7) - 3;
    if (d === 0) d = 1;
    cur = Math.min(base + span, Math.max(base - span, cur + d));
    el.textContent = cur.toLocaleString('en-US');
    el.classList.add('mvt-tick');
    setTimeout(function () { el.classList.remove('mvt-tick'); }, 400);
    setTimeout(step, 2200 + Math.random() * 2800);
  }
  setTimeout(step, 2500);
})();

/* sticky sidebar: a tall sidebar scrolls with the page until its bottom shows, then stays */
(function () {
  var aside = document.querySelector('.mvt-aside');
  if (!aside) return;
  var gap = 16;
  function fit() {
    var h = aside.offsetHeight, vh = window.innerHeight;
    aside.style.top = (h + gap * 2 > vh ? (vh - h - gap) : gap) + 'px';
  }
  fit();
  window.addEventListener('resize', fit);
  window.addEventListener('load', fit);
  if ('ResizeObserver' in window) new ResizeObserver(fit).observe(aside);
})();